import * as React from 'react';

import { AddButtonUI } from './add-button';
import { GridItemWrapper } from './grid-item-wrapper';

interface OptionalFieldProps {
  visible: boolean;
  label: string;
  onClick: () => void;
}

export const OptionalField: React.FC<OptionalFieldProps> = ({ visible, label, onClick }) => {
  if (visible) {
    return null;
  }

  return (
    <GridItemWrapper>
      <AddButtonUI css={styles.button} label={label} onClick={onClick} />
    </GridItemWrapper>
  );
};

const styles = {
  button: {
    margin: '0 0 4px',
  },
};
